<template>
	<div class="crud-label-container" :class="classList">
		<label class="crud-label">{{ label }}
			<img v-if="labelHint" :src="require(`@/common/assets/icons/help-white-text.svg`)" :title="labelHint" alt="hint"/>

			<span v-if="subLabel">{{ subLabel }}</span>
		</label>

		<InnerCheckbox
			v-if="hasCheckBox"
			:checkboxData="checkboxData"
			@valueHasChanged="valueHasChanged"
		/>
	</div>
</template>
<script>
	import InnerCheckbox from "./InnerCheckbox.vue";
	import { CRUD_LABEL_PROPS } from "./props/CrudLabelProps.js";


	export default {
		name: "CrudLabel",
		components: {
			InnerCheckbox
		},
		props: {
			...CRUD_LABEL_PROPS
		},
		methods: {
			valueHasChanged(data) {
				this.$emit('valueHasChanged', data);
			}
		}
	}
</script>
